import React from "react";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import UtilService from "../../services/UtilService";
import CustomChip from "../components/CustomChip";

export function getColumns({ onViewLogs, onSubscriptionClick } = {}) {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1,
            editable: false,
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            editable: false,
            alignItems: "center",
        },
        {
            field: "emailVerified",
            headerName: "Email Verified",
            flex: 1,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return <CustomChip value={params.value} trueFalse />;
            },
        },
        {
            field: "enabled",
            headerName: "Subscribed",
            flex: 1,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return <CustomChip value={params.value} trueFalse />;
            },
        },
        {
            field: "createdAt",
            headerName: "Created",
            flex: 1,
            editable: false,
            alignItems: "center",
            renderCell: (params) => {
                return UtilService.formatDate(params.value);
            },
        },
        {
            field: "lastSentAt",
            headerName: "Last sent",
            flex: 1,
            editable: false,
            sortable: false,
            alignItems: "center",
            renderCell: (params) => {
                return params.value ? UtilService.formatDate(params.value) : "—";
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 168,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const subscribed = params.row?.enabled === true;
                return (
                <Box
                    sx={{ display: "flex", alignItems: "center", gap: 0.5, height: "100%" }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <Tooltip title="Send log history">
                        <span>
                            <IconButton
                                size="small"
                                aria-label="Send log history"
                                disabled={!params.row?.email}
                                onClick={() => onViewLogs?.(params.row)}
                            >
                                <ListAltIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Button
                        size="small"
                        variant="text"
                        disabled={!params.row?.id}
                        onClick={() => onSubscriptionClick?.(params.row)}
                    >
                        {subscribed ? "Unsubscribe" : "Subscribe"}
                    </Button>
                </Box>
                );
            },
        },
    ];
}
